import { ChangeEvent, useCallback, useContext, useState } from "react";
import { Col, Form, Input, ModalProps, Row, Space, Typography } from "antd";
import { TeamOutlined, UserOutlined, IdcardOutlined } from "@ant-design/icons";

import SimpleModal from "../../../../../components/SimpleModal";
import AppUsersList from "../AppUsersList";
import { formatCpf } from "../../../../../utils/Masks";
import { ThemeContext } from "../../../../../contexts/ThemeContext";

const { Text } = Typography;

interface IProps extends ModalProps {
    onClose: () => void;
}

export default function AppUsersModal({ onClose }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const [name, setName] = useState<string>('');
    const [cpf, setCpf] = useState<string>('');

    const onChangeName = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    }, []);

    const onChangeCpf = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setCpf(formatCpf(e.target.value));
    }, []);

    return (
        <SimpleModal
            open={true}
            title={
                <Space align="center" size={8}>
                    <TeamOutlined style={{ color: '#1677ff', fontSize: 18 }} />
                    <span style={{ fontSize: 16, fontWeight: 600 }}>Usuários Destinatários</span>
                </Space>
            }
            onOk={onClose}
            onCancel={onClose}
            okButtonProps={{
                type: 'default',
            }}
            cancelButtonProps={{
                hidden: true,
            }}
            okText="Fechar"
            width={580}
            closable
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                    paddingTop: 8,
                }}
            >
                <div
                    style={{
                        padding: '12px 14px',
                        backgroundColor: isDark ? '#141414' : '#f8fafc',
                        borderRadius: 8,
                        border: `1px solid ${isDark ? '#303030' : '#e2e8f0'}`,
                    }}
                >
                    <Form layout="vertical">
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <Text strong style={{ fontSize: 12 }}>
                                            Buscar por Nome
                                        </Text>
                                    }
                                    style={{ marginBottom: 0 }}
                                >
                                    <Input
                                        placeholder="Ex: Maria da Silva"
                                        prefix={<UserOutlined style={{ color: '#94a3b8' }} />}
                                        value={name}
                                        onChange={onChangeName}
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <Text strong style={{ fontSize: 12 }}>
                                            Buscar por CPF
                                        </Text>
                                    }
                                    style={{ marginBottom: 0 }}
                                >
                                    <Input
                                        placeholder="000.000.000-00"
                                        prefix={<IdcardOutlined style={{ color: '#94a3b8' }} />}
                                        value={cpf}
                                        onChange={onChangeCpf}
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>

                <AppUsersList
                    filters={{
                        name,
                        cpf,
                    }}
                />
            </div>
        </SimpleModal>
    );
}